<template>
    <div :class="containerClass">
        <CompassTooltip
            v-if="showBackButton"
            :content="getLabelTooltip"
            placement="bottom-start"
            :arrow="false"
            :disabled="!showTooltip"
        >
            <CompassIconButton icon="caret-left" @click="handleClick" />
        </CompassTooltip>
        <CompassColoredIcon
            v-if="hasPrefixColoredIcon"
            class="heading__icon"
            :icon="prefixColoredIcon.icon"
            :color="prefixColoredIcon.color"
            :size="iconSize"
        />
        <component :is="variant" :class="fontClass">
            {{ labelTitle }}
        </component>
    </div>
</template>

<script>
export default {
    props: {
        labelTitle: {
            type: String,
            required: true,
        },
        showTooltip: {
            type: Boolean,
            default: true,
        },
        labelTooltip: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: 'h1',
        },
        prefixColoredIcon: {
            type: Object,
            default: () => ({}),
        },
        showBackButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        getLabelTooltip() {
            return this.labelTooltip || this.$t.__('common.actions.back');
        },
        containerClass() {
            return ['heading', `heading--${this.variant.toLowerCase()}`];
        },
        fontClass() {
            return ['heading__title', `typographies-heading-${this.variant.toLowerCase()}`];
        },
        iconSize() {
            return this.variant === 'h2' ? 'large' : 'medium';
        },
        hasPrefixColoredIcon() {
            return Object.keys(this.prefixColoredIcon).length > 0;
        },
    },
    methods: {
        handleClick() {
            this.$emit('go-back');
        },
    },
};
</script>

<style lang="scss" scoped>
.heading {
    display: flex;
    align-items: center;
    gap: var(--spacing-0);

    &--h1 {
        margin: 0 0 var(--spacing-4);
    }

    &--h2 {
        margin: 0 0 var(--spacing-3);

        .heading__icon {
            margin-right: var(--spacing-1);
        }
    }

    &--h3,
    &--h4 {
        margin: 0 0 var(--spacing-1);

        .heading__icon {
            margin-right: var(--spacing-0);
        }
    }

    &--h5,
    &--h6 {
        margin: 0 0 var(--spacing-0);
    }

    &__icon {
        flex-shrink: 0;
    }

    &__title {
        margin: 0;
    }
}
</style>